<div class="insert-promo-code-block" *ngIf="shouldShowBlock">
  <div class="insert-promo-code-block-container" [ngClass]="{'hasCode': hasCode}" (click)="openModal()">
    <div class="insert-promo-code-block-content">
      <div class="insert-promo-code-block-icon">
        <img alt="{{promoType}}" src="/assets/images/{{'ICON-' + promoType + '.svg'}}" class="icon">
      </div>
      <div class="insert-promo-code-block-text">
        <p *ngIf="!hasCode" class="wt-text-base-m insert-promo-code-block-text-title wt-font-bold">
          {{promoType + '.HAVE_CODE' | translate}}
        </p>
        <div *ngIf="hasCode">
          <h4 class="sb-color-green title">{{promoType + '.HAS_CODE.TITLE' | translate}}</h4>
          <p class=" wt-text-base-m title"
             [innerHTML]="((promoSubtype ? promoType + '-' + promoSubtype : promoType) + '.HAS_CODE.TEXT') | translate:{ code: code }">
          </p>
        </div>

      </div>
      <div class="insert-promo-code-block-arrow" *ngIf="!hasCode">
        <img alt="Arrow" src="/assets/images/icon-promo-right.svg" class="icon">
      </div>
    </div>
  </div>
  <p class="wt-text-base-m insert-promo-code-block-info" [innerHTML]="promoType + '.MORE_INFO' | translate"></p>
</div>
